import { Clock } from 'lucide-react'

export const EmptyMemberTable = () => {
  return (
    <div className="flex h-[590px] flex-col items-center justify-center rounded-xl border-[1px] border-[#E5E5E5]">
      <Clock size={46} />
      <h2 className="mb-4 mt-2 text-xl font-semibold">
        Nenhum membro adicionado{' '}
      </h2>
      <p className="w-[520px] text-center font-medium text-black04">
        Adicione membros para começar a colaborar e gerenciar transações nesta
        equipe.
      </p>
    </div>
  )
}
